import React from "react";

import { FormControlLabel, Radio } from "@mui/material";

interface Props {
  label: string;
  selected: boolean;
  onChange: () => void;
}

export const RadioRow: React.FC<Props> = ({ label, selected, onChange }) => {
  return (
    <FormControlLabel
      control={
        <Radio
          checked={selected}
          onChange={onChange}
          size="small"
          sx={{ p: "2px", "& .MuiSvgIcon-root": { fontSize: 18 } }}
        />
      }
      label={label}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "4px",
        m: 0,
        mb: "4px",
        cursor: "pointer",
        "& .MuiFormControlLabel-label": { fontSize: 13, color: "#374151" }
      }}
    />
  );
};
